import {defineMessages} from 'react-intl';

export default defineMessages({
    title: {
        id: 'newsletter.sidebar.title',
        defaultMessage: 'Alerta de cupons',
    }
});
